<h4 class="files-section-title">Prescriber files</h4>

<form [formGroup]="uploadForm()">
  <div class="signature">
    <div class="prescriber-files">
      <div class="upload-signature">
        <h6>Upload signature file</h6>
        <div class="form-upload-container">
          <div class="upload-container">
            <div class="form-group choose-file">
              <input
                #imageFileInput
                type="file"
                id="image"
                (change)="onSignatureImageFileChange($event, imageFileInput)"
                accept="image/png"
                />
              </div>
              <div class="form-group upload-button">
                <button
                  class="btn btn-success"
                  type="submit"
                  (click)="signatureImageSubmitClick(userId)"
                  [disabled]="uploadForm().controls['image'].invalid"
                  >
                  Submit signature file
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="image-container">
          @if (!signatureExists() && !signatureImgSrc()) {
            <div class="file-placeholder">Please upload file</div>
          }
          @if (signatureExists() && !signatureImgSrc()) {
            <div class="file-placeholder uploaded-message">Image already uploaded</div>
          }
          @if (signatureImgSrc()) {
            <img [src]="signatureImgSrc()" alt="Signature Preview" class="uploaded-image" />
          }
        </div>
      </div>
      <div class="video">
        <div class="prescriber-files">
          <div class="upload-signature">
            <h6>Upload prescription approved file</h6>
            <div class="form-upload-container">
              <div class="upload-container">
                <div class="form-group choose-file">
                  <input
                    #approvedVideoFileInput
                    type="file"
                    id="video_approved"
                    (change)="onApprovedVideoFileChange($event, approvedVideoFileInput, uploadForm().controls['approvedVideo'])"
                    accept="video/*"
                    />
                  </div>
                  <div class="form-group upload-button">
                    <button
                      class="btn btn-success"
                      type="submit"
                      (click)="approvedVideoSubmitClick(userId)"
                      [disabled]="uploadForm().controls['approvedVideo'].invalid"
                      >
                      Submit video file
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="video-preview">
              @if (!approvedVideoExists() && !approvedVideoSrc) {
                <div class="file-placeholder">Please upload file</div>
              }
              @if (approvedVideoExists() && !approvedVideoSrc) {
                <div class="file-placeholder uploaded-message">Video already uploaded</div>
              }
              @if (approvedVideoSrc) {
                <video controls [src]="approvedVideoSrc" class="uploaded-video"></video>
              }
            </div>
          </div>
        </div>
      </div>


      <div class="video">
        <div class="prescriber-files">
          <div class="upload-signature">
            <h6>Upload prescription not approved file</h6>
            <div class="form-upload-container">
              <div class="upload-container">
                <div class="form-group choose-file">
                  <input
                    #notApprovedVideoFileInput
                    type="file"
                    id="video_not_approved"
                    (change)="onNotApprovedVideoFileChange($event, notApprovedVideoFileInput, uploadForm().controls['notApprovedVideo'])"
                    accept="video/*"
                    />
                  </div>
                  <div class="form-group upload-button">
                    <button
                      class="btn btn-success"
                      type="submit"
                      (click)="notApprovedVideoSubmitClick(userId)"
                      [disabled]="uploadForm().controls['notApprovedVideo'].invalid"
                      >
                      Submit video file
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="video-preview">
              @if (!notApprovedVideoExists() && !notApprovedVideoSrc) {
                <div class="file-placeholder">Please upload file</div>
              }
              @if (notApprovedVideoExists() && !notApprovedVideoSrc) {
                <div class="file-placeholder uploaded-message">Video already uploaded</div>
              }
              @if (notApprovedVideoSrc) {
                <video controls [src]="notApprovedVideoSrc" class="uploaded-video"></video>
              }
            </div>
          </div>
        </div>
      </form>
